import Vue from 'vue'
import store from '@/store'

/**
 * Action Permission directive
 * Directive usage:
 *  - When need to control action Used on components with level permissions v-action:[method] , As follows:
 *    <i-button v-action:add >Add user</a-button>
 *    <a-button v-action:delete>Delete user</a-button>
 *    <a v-action:edit @click="edit(record)">Modify</a>
 *
 *  - When the current user has no permission, components using this directive will be hidden
 *  - When backend permission and pro When the provided mode differs, only modify the permission filtering here
 *
 *  @see https://github.com/sendya/ant-design-pro-vue/pull/53
 */
const action = Vue.directive('action', {
  inserted: function (el, binding, vnode) {
    const actionName = binding.arg
    const roles = store.getters.roles
    if (!roles || !roles.permissions) {
      return
    }
    const elVal = vnode.context.$route.meta.permission
    const permissionId = elVal instanceof String && [elVal] || elVal
    roles.permissions.forEach(p => {
      if (!permissionId.includes(p.permissionId)) {
        return
      }
      if (p.actionList && !p.actionList.includes(actionName)) {
        el.parentNode && el.parentNode.removeChild(el) || (el.style.display = 'none')
      }
    })
  }
})

export default action
